module.exports = __webpack_public_path__ + "img/certificacion-hero.c254f6a5.png";